/* 알람 표시용 공통 포맷 — 컨텍스트와 토스트·드로어가 함께 쓴다 (순환 import 를 피하려고 별도 파일). */

const pad2 = (n) => String(n).padStart(2, '0');

/* 백엔드 심각도(ERROR/WARNING/INFO) → 화면 표기(CRITICAL/WARNING/INFO) */
export const severityKey = (s) => {
  const v = String(s || '').toUpperCase();
  if (v === 'ERROR' || v === 'CRITICAL') return 'CRITICAL';
  if (v === 'WARNING' || v === 'WARN') return 'WARNING';
  return 'INFO';
};

const parseDate = (raw) => {
  if (!raw) return null;
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatClock = (raw) => {
  const d = parseDate(raw);
  return d ? `${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}` : '—';
};

export const formatShortClock = (raw) => {
  const d = parseDate(raw);
  return d ? `${pad2(d.getHours())}:${pad2(d.getMinutes())}` : '—';
};

export const formatDateTime = (raw) => {
  const d = parseDate(raw);
  return d
    ? `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`
    : '—';
};
